import React, { useEffect, useState } from "react";
import { Cloud } from "lucide-react";
import api from "../lib/api";
import { Label } from "./ui/label";

const VARS = [["first_name", "Nome"], ["full_name", "Nome e cognome"], ["card_number", "Numero carta"], ["points", "Punti"], ["portal_url", "Link card"], ["body", "Testo del messaggio"], ["email", "Email"]];

// Comunicazioni: se il circuito usa la Cloud API, scelta del template Meta e delle variabili per l'invio automatico
export function WaTemplatePicker({ value, onChange }) {
  const [opts, setOpts] = useState({ available: false, templates: [] });
  useEffect(() => { api.get("/wa-cloud/manual-options").then((r) => setOpts(r.data)).catch(() => {}); }, []);
  if (!opts.available) return null;
  const tpl = opts.templates.find((t) => t.name === value?.name);
  const setName = (name) => { const t = opts.templates.find((x) => x.name === name); onChange(name ? { name, language: t?.language || "it", params: Array.from({ length: t?.n_params || 0 }, (_, i) => (i === 0 ? "first_name" : i === 1 ? "body" : "")) } : null); };
  return (
    <div className="rounded-lg border border-sky-500/30 bg-sky-500/5 p-3 space-y-2" data-testid="comm-wa-template">
      <Label className="text-zinc-300 flex items-center gap-1"><Cloud className="h-3 w-3 text-sky-400" /> Invio automatico via WhatsApp Cloud API (template Meta approvato)</Label>
      <select value={value?.name || ""} onChange={(e) => setName(e.target.value)} data-testid="comm-wa-template-select" className="w-full h-10 rounded-md border bg-zinc-950 border-zinc-800 px-2 text-sm">
        <option value="">— Nessun template: genera i link wa.me da aprire manualmente —</option>
        {opts.templates.map((t) => <option key={t.id} value={t.name}>{t.name} · {t.language} · {t.n_params} variabil{t.n_params === 1 ? "e" : "i"}</option>)}
      </select>
      {tpl && <p className="text-[11px] text-zinc-500 whitespace-pre-wrap">{tpl.body}</p>}
      {tpl && tpl.n_params > 0 && (
        <div className="flex flex-wrap gap-2">
          {value.params.map((p, i) => (
            <label key={i} className="text-[11px] flex items-center gap-1">{`{{${i + 1}}}`} =
              <select value={p} onChange={(e) => { const params = [...value.params]; params[i] = e.target.value; onChange({ ...value, params }); }} data-testid={`comm-wa-param-${i + 1}`} className="h-7 rounded border bg-zinc-950 border-zinc-800 px-1 text-[11px]">
                <option value="">—</option>
                {VARS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
            </label>
          ))}
        </div>
      )}
      {tpl && <p className="text-[11px] text-sky-300">I messaggi partono subito dal numero WhatsApp del circuito, senza aprire WhatsApp Web. Il testo composto sotto viene usato dove scegli "Testo del messaggio".</p>}
    </div>
  );
}
